import api from "../services/api";

const updateTicketStatus = async ({
  ticket,
  status,
  userId,
  skipFarewell = false,
  history,
  setCurrentTicket,
  setLoading,
  onError,
}) => {
  if (!ticket) return;

  setLoading?.(true);

  try {
    await api.put(`/tickets/${ticket.id}`, {
      status,
      userId: userId || null,
      useIntegration: status === "closed" ? false : ticket.useIntegration,
      promptId: status === "closed" ? false : ticket.promptId,
      integrationId: status === "closed" ? false : ticket.integrationId,
      ...(skipFarewell && { skipFarewell: true }),
    });

    if (status === "open") {
      setCurrentTicket?.({ ...ticket, code: "#open" });
    } else {
      setCurrentTicket?.({ id: null, code: null });
      history?.push("/tickets");
    }
  } catch (err) {
    onError?.(err);
  } finally {
    setLoading?.(false);
  }
};

export default updateTicketStatus;
